import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
  faEnvelope,
  faLanguage,
  faLocationCrosshairs,
  faPhone,
  faSearch,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { NotificationService } from '@progress/kendo-angular-notification';
import { process } from '@progress/kendo-data-query';
import {
  filePdfIcon,
  filterIcon,
  searchIcon,
  SVGIcon,
  trashIcon,
} from '@progress/kendo-svg-icons';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { AdminService } from 'src/app/modules/administration/services/admin.service';
import {
  dialogAnimationDuration,
  dialogTimer,
} from 'src/app/shared/constants/dialog-specs';
import { NOTIFICATION_MESSAGES } from 'src/app/shared/constants/notification-messages';
import { IReferenceData } from 'src/app/shared/interfaces/form/reference-data.model';
import { ReferenceStore } from 'src/app/stores/reference.store';
import { FilterParam } from '../../interface/agency-filter';
import { AgencyList, VwAgency } from '../../interface/agency-list';
import { AddWaitlistModel } from '../../models/add-waitlist-model';
import { Boroughs } from '../enums/boroughs';
import { WaitlistNumbers } from '../enums/waitlist-numbers';
import { last, orderBy } from 'lodash';
import { VwCompleteWorklist } from 'src/app/modules/administration/interfaces/complete-worklist';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-assign-student-to-agencies',
  templateUrl: './assign-student-to-agencies.component.html',
  styleUrls: ['./assign-student-to-agencies.component.scss'],
  standalone: false,
})
export class AssignStudentToAgenciesComponent implements OnInit {
  @ViewChild(DataBindingDirective) dataBinding: DataBindingDirective;
  @Input() showAssignStudentAgency: boolean = false;
  @Input() agencySk: string;
  @Input() globalMySelection: string[];
  @Input() selectedAgency: VwCompleteWorklist[] = [];
  form: FormGroup;
  showData: boolean;
  public searchIcon: SVGIcon = searchIcon;
  public pdfSVG: SVGIcon = filePdfIcon;
  public gridData: AgencyList[] = [];
  public gridDetails: VwAgency[] = [];
  public masterGridDetails: VwAgency[] = [];
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  showAssignStudentToAgencies$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);
  loadSpinner: boolean;
  showContactDialog: boolean = false;
  contactData: VwAgency;
  public expanded: boolean = false;
  moreDetailsItem: VwAgency;
  itemIndexNumber: number;
  showFilter: boolean = false;
  referenceData: {
    district: IReferenceData[];
    language: IReferenceData[];
    borough: IReferenceData[];
  } = {
    district: [],
    language: [],
    borough: [],
  };
  public filterIcon: SVGIcon = filterIcon;
  filterParam: FilterParam;
  public trashIcon: SVGIcon = trashIcon;
  readonly midRange: number = 0;
  readonly maxGridDataLength: number = 3;
  minRange: number = this.midRange;
  public waitlistValues: number[] = [
    WaitlistNumbers.Zero,
    WaitlistNumbers.Fifty,
    WaitlistNumbers.Hundred,
    WaitlistNumbers.OneHundredAndFifty,
    WaitlistNumbers.TwoHundred,
  ];

  readonly noWebsiteAvailableForThisAgency: string =
    'No website available for this agency.';

  constructor(
    library: FaIconLibrary,
    private adminService: AdminService,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private notificationService: NotificationService,
    private referenceStore: ReferenceStore,
    private loadingService: LoadingService,
  ) {
    library.addIcons(
      faLocationCrosshairs,
      faLanguage,
      faSearch,
      faTrash,
      faPhone,
      faEnvelope
    );

    this.filterParam = {
      agencyName: '',
      district: [],
      borough: [],
      language: [],
      range: null,
      locationCode: '',
    };

    this.gridData = [];
  }
  
  
  ngOnInit(): void {
    this.getMdeAgency();
  }

  getMdeAgency(): void {
    this.loadingService?.show();
    const selectedStudent = last(this.selectedAgency)?.homeDistrictName?.replace('District', '')?.trim();
    this.adminService
      .getMDEAgencyList(this.filterParam)
      .subscribe((res: VwAgency[]) => {
        this.gridDetails = orderBy(
        res,
        [
          (agency: VwAgency) =>
            agency.geographicalDistrictCode.toString() === selectedStudent ? 0 : 1,
          'waitListCount'
        ],
        ['asc', 'asc']
      );
      this.loadingService?.hide();
        this.masterGridDetails = this.gridDetails;
        if (this.gridDetails) {
          this.gridDetails.forEach((element: VwAgency) => {
            let districts: string = '';
            if (element?.serviceBronx) {
              districts = Boroughs.Bronx;
            }
            if (element?.serviceBrooklyn) {
              districts =
                districts === ''
                  ? Boroughs.Brooklyn
                  : `${districts}, ${Boroughs.Brooklyn}`;
            }
            if (element?.serviceManhattan) {
              districts =
                districts === ''
                  ? Boroughs.Manhattan
                  : `${districts}, ${Boroughs.Manhattan}`;
            }
            if (element.serviceQueens) {
              districts =
                districts === ''
                  ? Boroughs.Queens
                  : `${districts}, ${Boroughs.Queens}`;
            }
            if (element.serviceStatenIsland) {
              districts =
                districts === ''
                  ? Boroughs.StatenIsland
                  : `${districts}, ${Boroughs.StatenIsland}`;
            }
            element.boroNames = districts;
          });
        }
        this.loadSpinner = false;
      });
  }

  initalizeForm(): FormGroup {
    return (this.form = this.fb.group({
      agencyName: null,
      district: [[]],
      borough: [[]],
      language: [[]],
      range: null,
      locationCode: '',
    }));
  }

  getReferenceData(): void {
    combineLatest([
      this.referenceStore.district$,
      this.referenceStore.language$,
      this.referenceStore.borough$,
    ]).subscribe(
      ([district, language, borough]: [
        IReferenceData[],
        IReferenceData[],
        IReferenceData[]
      ]) => {
        this.referenceData.district = district;
        this.referenceData.language = language;
        this.referenceData.borough = borough;
      }
    );
  }

  addDistricts(): void {
    this.gridDetails.forEach((element: VwAgency) => {
      let districts: string = '';
      if (element.serviceBronx) {
        districts = Boroughs.Bronx;
      }
      if (element.serviceBrooklyn) {
        districts =
          districts === ''
            ? Boroughs.Brooklyn
            : `${districts}, ${Boroughs.Brooklyn}`;
      }
      if (element.serviceManhattan) {
        districts =
          districts === ''
            ? Boroughs.Manhattan
            : `${districts}, ${Boroughs.Manhattan}`;
      }
      if (element.serviceQueens) {
        districts =
          districts === ''
            ? Boroughs.Queens
            : `${districts}, ${Boroughs.Queens}`;
      }
      if (element.serviceStatenIsland) {
        districts =
          districts === ''
            ? Boroughs.StatenIsland
            : `${districts}, ${Boroughs.StatenIsland}`;
      }
      element.boroNames = districts;
    });
  }

  onHideHandler(): void {
    this.closeModal.next();
    this.resetFilter();
  }

  resetFilter(): void {
    this.gridDetails = [...this.masterGridDetails];
    this.loadSpinner = false;
  }

  refreshData(): void {
    this.getMdeAgency();
  }

  public onFilter(value: Event): void {
    const inputValue: Event = value;
    if (inputValue) {
      this.gridDetails = process(this.masterGridDetails, {
        filter: {
          logic: 'or',
          filters: [
            {
              field: 'siteLocation',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'siteCode',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'addressLine1',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'addressLine2',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'city',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'boroCd',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'languageList',
              operator: 'contains',
              value: inputValue,
            },
            {
              field: 'boroNames',
              operator: 'contains',
              value: inputValue,
            },
          ],
        },
      }).data;

      if (this.dataBinding) {
        this.dataBinding.skip = 0;
      }
    } else {
      this.resetFilter();
    }
  }

  onShowHandler(): void {
    this.refreshData();
  }

  applyFilters(): void {
    this.showFilter = false;
    if (typeof this.form.value !== 'string') {
      this.filterParam = this.form.value;
      this.getMdeAgency();
    }
  }

  clearFilteredData(): void {
    this.gridDetails = JSON.parse(JSON.stringify(this.masterGridDetails));
  }

  clearFilters(): void {
    this.initalizeForm();
  }

  selectedData(data: AgencyList): void {
    if (
      this.gridData.length < this.maxGridDataLength &&
      !this.gridData.some(
        (res: AgencyList) =>
          res.agencySk === data.agencySk &&
          res.buildingCode === data.buildingCode
      )
    ) {
      this.gridData.push(data);
      this.gridData = [...this.gridData];
    }
    this.cdr.detectChanges();
  }
  removeData(data: AgencyList): void {
    this.gridData = this.gridData.filter((item: AgencyList) => item !== data);
    this.cdr.detectChanges();
  }
  clearAll(): void {
    this.gridData = [];
    this.cdr.detectChanges();
  }

  assignSelectedData(): void {
    this.loadSpinner = true;

    const details: AddWaitlistModel = new AddWaitlistModel({
      selectedAgency: this.gridData,
      selectedStudents: this.globalMySelection,
    });
    this.adminService.addToMDWaitlist(details).subscribe((data: boolean) => {
      if (data) {
        this.notificationService.show({
          content: NOTIFICATION_MESSAGES.mdeAssign,
          cssClass: 'notification-success',
          hideAfter: dialogTimer,
          position: { horizontal: 'center', vertical: 'top' },
          animation: { type: 'slide', duration: dialogAnimationDuration },
          type: { style: 'success', icon: true },
        });
        this.loadSpinner = false;
        this.gridData = [];
        this.closeModal.next();
      }
    });
  }

  openContactDialog(data: VwAgency): void {
    this.contactData = data;
    this.showContactDialog = true;
  }

  // Method to close the dialog
  closeContactDialog(): void {
    this.showContactDialog = false;
  }

  openWebsite(data: VwAgency): void {
    if (data.weburl) {
      // Open the web URL in a new tab
      window.open(data.weburl, '_blank');
    } else {
      this.notificationService.show({
        content: this.noWebsiteAvailableForThisAgency,
        cssClass: 'notification-warning',
        hideAfter: 5000,
        position: { horizontal: 'center', vertical: 'top' },
        animation: { type: 'slide', duration: 300 },
        type: { style: 'warning', icon: true },
      });
    }
  }

  toggleMoreDetails(item: VwAgency, index: number): void {
    if (this.itemIndexNumber === index && this.expanded) {
      // Collapse if same item is clicked again
      this.expanded = false;
      this.itemIndexNumber = -1;
      this.moreDetailsItem = null;
    } else {
      // Open for new item
      this.itemIndexNumber = index;
      this.moreDetailsItem = item;
      this.expanded = true;
    }
  }
  openFilterDialog(): void {
    this.initalizeForm();
    this.getReferenceData();
    this.showFilter = true;
  }

  public title: (value: number) => string = (value: number): string => {
    return this.waitlistValues.includes(value) ? `${value}` : '';
  };
}
